export default "__VITE_ASSET__BS$Ji8TK__"